var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetlify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8541 64.28H55.9976L55.4249 63.7074V47.6573C55.4249 44.8017 54.3028 42.5884 50.8591 42.511C49.0869 42.4646 47.0593 42.511 44.8925 42.5961L44.5675 42.9289V49.4139V63.6997L43.9948 64.2723H37.1383L36.5656 63.6997V36.2814L37.1383 35.7087H52.5694C58.5669 35.7087 63.4268 40.5686 63.4268 46.5661V63.7074L62.8541 64.28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0237 79.4712H26.0796L21.3668 74.7583V73.8142L28.5715 66.6094H33.563L34.2285 67.2749V72.2664L27.0237 79.4712Z",
    fill: "#32E6E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3668 26.1668V25.2227L26.0796 20.5098H27.0237L34.2285 27.7145V32.706L33.563 33.3716H28.5715L21.3668 26.1668Z",
    fill: "#32E6E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9988 54.003H0.572666L0 53.4303V46.5583L0.572666 45.9857H27.9988L28.5714 46.5583V53.4303L27.9988 54.003Z",
    fill: "#32E6E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4274 54.003H72.0011L71.4284 53.4303V46.5583L72.0011 45.9857H99.4274L100 46.5583V53.4303L99.4274 54.003Z",
    fill: "#32E6E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0455 27.1419V6.5723L46.6181 5.99963H53.4902L54.0629 6.5723V27.1419L53.4902 27.7145H46.6181L46.0455 27.1419Z",
    fill: "#32E6E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0455 93.4163V72.8469L46.6181 72.2742H53.4902L54.0629 72.8469V93.4163L53.4902 93.9889H46.6181L46.0455 93.4163Z",
    fill: "#32E6E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetlify);
export default __webpack_public_path__ + "static/media/Netlify.42e605544a89f08284e8766a425703ed.svg";
export { ForwardRef as ReactComponent };